const colors = {
  statesErrorTertiary: "#F9E1E6",
  statesErrorTertiary60: "rgba(249, 225, 230, 0.6)",
  statesErrorSecondary: "#C57282",
  statesErrorPrimary: "#ED4434",
  statesErrorPrimary50: "rgba(237, 68, 52, 0.5)",
  statesSuccessTertiary40: "rgba(193, 239, 201, 0.4)",
  statesSuccessTertiary: "#C1EFC9",
  statesSuccessSecondary: "#7EB694",
  statesSuccessPrimary: "#3ABD66",
  brandBlue: "#4a90e2",
  brandBlue20: "rgba(74, 144, 226, 0.2)",
  brandBlue50: "rgba(74, 144, 226, 0.5)",
  brandAqua: "#33E6EE",
  brandLightBlue: "#c8ebf2",
  brandLightBlue20: "rgba(200, 235, 242, 0.2)",
  brandLightBlue40: "rgba(200, 235, 242, 0.4)",
  brandLightBlue60: "rgba(200, 235, 242, 0.6)",
  brandLightGreen: "#c1efe0",
  brandLightYellow: "#fffedc",
  steelBlue: "#21899D",
  yellow: "#764400",
  green: "#092215",
  gray: "rgba(100, 100, 111, 0.2)",
  gray03: "rgba(0, 0, 0, 0.03)",
  gray04: "rgba(0, 0, 0, 0.04)",
  gray05: "rgba(0, 0, 0, 0.05)",
  gray10: "rgba(0, 0, 0, 0.1)",
  gray12: "rgba(0, 0, 0, 0.12)",
  gray20: "rgba(0, 0, 0, 0.2)",
  gray30: "rgba(0, 0, 0, 0.3)",
  gray40: "rgba(0, 0, 0, 0.4)",
  gray50: "rgba(0, 0, 0, 0.5)",
  gray60: "rgba(0, 0, 0, 0.6)",
  gray65: "rgba(0, 0, 0, 0.65)",
  gray80: "rgba(0, 0, 0, 0.8)",
  gray87: "rgba(0, 0, 0, 0.87)",
  gray100: "rgba(0, 0, 0, 1)",
  lightGray: "#F9FAFB",
  lighterGray: "#FAFAFA",
  hoverGray: "#f5f5f5",
  darkGray: "#D4D4D8",
  borderGray: "#E0E0E0",
  hoverBlue: "#E3F2FD",
  iconGray: "#4A5565",
  textDark: "#1A1A1A",
  placeholderGray: "#6B7282",
  badgeBlue: "#1448E6",
  badgeBlueLight: "#DCEAFF",
  badgeBlueBorder: "#BEDBFF",
  mediumGray: "#6C757D",
  activeBlue: "#2296F3",
  activeBlueHover: "#3EA1F5",
  primaryBlue: "#155DFC",
  lightBlueBg: "#DBEAFF",
  veryLightBlueBg: "#F8FAFF",
  darkBlueText: "#1C388E",
  primaryBlueHover: "#1976D2",
  reportBorderGray: "#E6E7EB",
  reportDelayBg: "#FFFDFA",
  reportErrorBg: "#FFFEF8",
  reportDelayIcon: "#FA823F",
  reportErrorIcon: "#EB9C3C",
  reportTitle: "#364154",
  reportCardBg: "#F3F4F6",
  reportCardBorder: "#E6E8EC",
  fundusOlderBg: "#FFF1E4",
  fundusExpected: "#E0B64A",
  fundusExpectedBg: "#FAEECD",
  fundusExpectedText: "#6B5312",
  successLightBg: "#DFF6E5",
  fundusYoungerText: "#14572B",
  sleepBetterText: "#14672F",
  sleepWorseBg: "#FDECE1",
  sleepWorseText: "#8A3D12",
  sleepNeutralBg: "#EDEFF2",
  sleepLatestHeaderBg: "#EAF0FB",
  sleepRowHoverBg: "#FBFCFE",
  sleepSeverityNormalText: "#2FA95C",
  sleepSeverityMildText: "#C99A2E",
  sleepSeverityModerateText: "#E5702A",
  sleepSeveritySevereText: "#D93A2B",
  sleepRowHighlightBg: "#F7F9FD",
  sleepPositionSupine: "#4C8696",
  sleepPositionProne: "#598BD2",
  sleepPositionRight: "#3859A9",
  sleepPositionLeft: "#283F83",
  insightPurple: "#6C4BB8",
  insightTeal: "#0E8FA3",
  insightGreen: "#2A9A52",
  insightOrange: "#E06520",
  insightYellow: "#9C7A12",
} as const

export default colors
